import type { ResetEmailResponse } from '../types/socialPasswordReset';
import type { PasswordResetEditResponse } from '../types/passwordResetEdit';
import { wrapFetch } from '../libs/fetch';

type SocialResetEmailParams = {
  email: string;
};

export const sendResetEmail = async (body: string, csrfToken: string) => {
  return await wrapFetch<ResetEmailResponse>('/api/v1/password_resets', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken,
    },
    body,
    credentials: 'same-origin',
  });
};

export const sendSocialResetEmail = async (
  params: SocialResetEmailParams,
  csrfToken: string
) => {
  return await wrapFetch<ResetEmailResponse>('/api/v1/password_resets/social_person', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken,
    },
    body: JSON.stringify(params),
    credentials: 'same-origin',
  });
};

export const updatePassword = async (
  token: string,
  body: string,
  csrfToken: string
) => {
  return await wrapFetch<PasswordResetEditResponse>(`/api/v1/password_resets/${token}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken,
    },
    body,
    credentials: 'same-origin',
  });
};
